import "lite-youtube-embed";
import { zoom } from "./partials/image-zoom";
import BasePage from "./base-page";

class Product extends BasePage {
  onReady() {
    app.watchElements({
      totalPrice: ".total-price",
      beforePrice: ".before-price",
      startingPriceTitle: ".starting-price-title",
      priceContainer: "#cutstom-product-prices",
      discountElement: "#custom-discount-amount",
      productSku: ".product-sku",
    });
    this.initProductOptionValidations();
    this.initFslightbox();
    this.IRT__Discount();

    if (imageZoom) {
      this.initImagesZooming();
      // listen to screen resizing
      window.addEventListener("resize", () => this.initImagesZooming());
    }
  }
  initFslightbox() {
    const lightboxTriggers = document.querySelectorAll("[data-fslightbox]");
    if (!lightboxTriggers.length) return;

    lightboxTriggers.forEach((trigger) => {
      trigger.addEventListener("click", async (e) => {
        e.preventDefault();
        try {
          if (!window.FsLightbox) {
            const { default: Fslightbox } = await import("fslightbox");
            window.FsLightbox = Fslightbox;
            if (typeof refreshFsLightbox === "function") {
              refreshFsLightbox();
            }
          }
          setTimeout(() => {
            const lightbox = new window.FsLightbox();
            lightbox.props.sources = [trigger.href];
            lightbox.props.types = [trigger.dataset.type || "image"];
            if (trigger.dataset.caption) {
              lightbox.props.captions = [trigger.dataset.caption];
            }
            if (trigger.dataset.infinite === "false") {
              lightbox.props.infinite = false;
            }
            lightbox.props.initialSlide =
              parseInt(trigger.dataset.slidIndex) || 0;
            lightbox.open(trigger.dataset.slidIndex || 0);
          }, 50);
        } catch (error) {
          console.error(error);
        }
      });
    });
  }
  initProductOptionValidations() {
    document
      .querySelector(".product-form")
      ?.addEventListener("change", function () {
        this.reportValidity() && salla.product.getPrice(new FormData(this));
      });
  }

  initImagesZooming() {
    const imageZoom = document.querySelector(
      ".image-slider .magnify-wrapper.swiper-slide-active .img-magnifier-glass",
    );
    if (window.innerWidth < 1024 || imageZoom) return;

    setTimeout(() => {
      const image = document.querySelector(
        ".image-slider .swiper-slide-active img",
      );
      zoom(image?.id, 2);
    }, 250);

    // Check if the slider element exists before adding event listener
    const slider = document.querySelector("salla-slider.details-slider");
    if (slider) {
      slider.addEventListener("slideChange", (e) => {
        setTimeout(() => {
          const imageZoom = document.querySelector(
            ".image-slider .swiper-slide-active .img-magnifier-glass",
          );
          if (window.innerWidth < 1024 || imageZoom) return;
          const image = document.querySelector(
            ".image-slider .magnify-wrapper.swiper-slide-active img",
          );
          zoom(image?.id, 2);
        }, 250);
      });
    }
  }

  registerEvents() {
    salla.event.on("product::price.updated.failed", () => {
      app.element(".price-wrapper").classList.add("hidden");
      const outOfStock = app.element(".out-of-stock");
      outOfStock.classList.remove("hidden");
      outOfStock.classList.remove("scale-pulse");
      void outOfStock.offsetWidth; // trigger reflow
      outOfStock.classList.add("scale-pulse");
    });
    salla.product.event.onPriceUpdated((res) => {
      app.element(".out-of-stock").classList.add("hidden");
      app.element(".price-wrapper").classList.remove("hidden");

      let data = res.data,
        is_on_sale = data.has_sale_price && data.regular_price > data.price;

      app.startingPriceTitle?.classList.add("hidden");

      app.totalPrice.forEach((el) => {
        el.innerHTML = salla.money(data.price);
      });
      app.beforePrice.forEach((el) => {
        el.innerHTML = salla.money(data.regular_price);
      });
      app.productSku.forEach((el) => {
        el.innerHTML = data.sku || "";
      });

      app.toggleClassIf(
        ".price_is_on_sale",
        "showed",
        "hidden",
        () => is_on_sale,
      );
      app.toggleClassIf(
        ".starting-or-normal-price",
        "hidden",
        "showed",
        () => is_on_sale,
      );

      app.anime(".total-price", { scale: [0.88, 1] });
    });

    app.onClick(
      "#btn-show-more",
      (e) =>
        app.all("#more-content", (div) => {
          e.target.classList.add("is-expanded");
          div.style = `max-height:${div.scrollHeight}px`;
        }) || e.target.remove(),
    );
  }
  IRT__Discount() {
    if (!app.priceContainer) return;

    let regularPrice = parseFloat(
      app.priceContainer.getAttribute("data-regular-price") || "0",
    );
    let salePrice = parseFloat(
      app.priceContainer.getAttribute("data-sale-price") || "0",
    );

    if (!isNaN(regularPrice) && !isNaN(salePrice) && regularPrice > salePrice) {
      let discount = new Intl.NumberFormat("en-SA", {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(regularPrice - salePrice);

      if (app.discountElement) {
        app.discountElement.innerHTML = `<i class="sicon-check-circle2"></i> ${salla.lang.get("pages.products.wafr")} ${discount} <i class="sicon-sar"></i>`;
        app.discountElement.style.color = "#16a34a";
        app.discountElement.style.border = "1px solid #16a34a";
      }
    }
  }
}

Product.initiateWhenReady(["product.single"]);
